import { createSlice } from "@reduxjs/toolkit";

const initialPaymentsState = {
  listLoading: false,
  actionsLoading: false,
  entities: [],
  entitiesLogs: [],
  totalCount: 0,
  totalCountLogs: 0,
  customerEntities: null,
  businessEntities: null,
  exportStatus: null,
  exportURL: null,
  filter: {
    category: null,
    type: null,
    status: null,
    customer: null,
    business: null,
    invoice: null,
    startDate: null,
    endDate: null,
    dueDateStart: null,
    dueDateEnd: null,
  },
  message: {
    error: null,
    success: null,
  },
};

export const callTypes = {
  list: "list",
  action: "action",
};

const normalizeError = (rawError) => {
  const errorData = rawError?.response?.data;
  const errors = errorData?.errors;
  const message =
    errorData?.message ||
    rawError?.message ||
    "Something went wrong. Please try again.";

  if (Array.isArray(errors)) {
    return errors;
  }

  if (errors && typeof errors === "object") {
    return Object.entries(errors).map(([key, value]) => `${key}->${value}`);
  }

  if (errors != null) {
    return errors;
  }

  return message;
};

export const paymentsSlice = createSlice({
  name: "payments",
  initialState: initialPaymentsState,
  reducers: {
    catchError: (state, action) => {
      const error = normalizeError(action.payload?.error);
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // save fetched products
    paymentsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    paymentLogFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entitiesLogs = entities;
      state.totalCountLogs = totalCount;
    },

    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },

    resetFormFilter: (state, action) => {
      state.filter = {
        category: null,
        type: null,
        status: null,
        customer: null,
        business: null,
        startDate: null,
        endDate: null,
      };
    },
    //deselect customer selected for order
    removeFilterBusiness: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.filter.business = null;
    },
    selectFilterCustomerForBusiness: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.filter.business = action.payload.business;
      state.customerEntities = null;
    },
    //deselect customer selected for order
    removeFilterCustomer: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.filter.customer = null;
    },
    // addCustomer
    selectFilterCustomerForCustomer: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.filter.customer = action.payload.customer;
      state.customerEntities = null;
    },

    selectFilterCategory: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { category } = action.payload;
      state.filter.category = category == 0 ? null : category;
    },
    selectFilterPaymentType: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { type } = action.payload;
      state.filter.type = type == 0 ? null : type;
    },
    selectFilterDate: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { date, isDueDate } = action.payload;
      if (date != null) {
        if (isDueDate === true) {
          state.filter.dueDateStart = date[0];
          state.filter.dueDateEnd = date[1];
        } else {
          state.filter.startDate = date[0];
          state.filter.endDate = date[1];
        }
      } else {
        state.filter.startDate = null;
        state.filter.endDate = null;
        state.filter.dueDateStart = null;
        state.filter.dueDateEnd = null;
      }
    },
    findCustomerByBusinessName: (state, action) => {
      const { entities } = action.payload;
      state.businessEntities = entities;
    },
    findCustomerByCustomerName: (state, action) => {
      const { entities } = action.payload;
      state.customerEntities = entities;
    },
    updateStatus: (state, action) => {
      const { status, url } = action.payload;
      state.exportStatus = status;
      state.exportURL = url;
    },
  },
});
